import { BaseNotificationContextEnum } from './base-notification-context.enum';

/**
 * Location notification context enum
 * @description Notification contexts specific to location subjects
 */
export enum LocationNotificationContextEnum {
	// Base contexts
	INSERTED = BaseNotificationContextEnum.INSERTED,
	UPDATED = BaseNotificationContextEnum.UPDATED,
	DELETED = BaseNotificationContextEnum.DELETED,

	// Location-specific contexts
	OPEN = 'open',
	CLOSED = 'closed',
}
